'use strict';
var arraySpeciesConstructor = require('../internals/array-species-constructor');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/array-species-create.js
// module id = 319
// module chunks = 0